import { combineReducers } from 'redux';
import { loginReducer } from './Login/reducers';
import { layoutReducer } from './Layout/reducers';
import { profileReducer } from './Profile/reducers';
import { b2bReducer } from './B2b/reducers';

export default combineReducers({
    login: loginReducer,
    layout: layoutReducer,
    profile: profileReducer,
    b2b: b2bReducer
});